import { useHasFeature } from '@/lib/useHasFeature';
import { QUOTE_CAROUSEL_FEATURE } from '@/lib/quoteCarousel/quoteCarouselFeature';
import { useFreecutStudioAccess } from '@/hooks/use-freecut-studio-access';

/** Whether a clip card offers "Carrossel de frases" and AutoCut Studio.
 *
 *  Both read the source video, so they need no render (`canMakeCarousel`,
 *  from `canMakeQuoteCarousel`) and are independent of social_publishing.
 *  The carousel needs the quote_carousel feature; the studio needs studio
 *  access (admins always have it). Flows whose clicks must stay inside them
 *  (the /calendar picker) pass `showCarouselAction: false`, since both
 *  actions navigate away. */
export function useClipExtraActions({
  canMakeCarousel,
  showCarouselAction = true,
}: {
  canMakeCarousel: boolean;
  showCarouselAction?: boolean;
}): { showCarousel: boolean; showStudio: boolean } {
  const hasQuoteCarousel = useHasFeature(QUOTE_CAROUSEL_FEATURE);
  const hasStudio = useFreecutStudioAccess();
  return {
    showCarousel: showCarouselAction && canMakeCarousel && hasQuoteCarousel,
    showStudio: showCarouselAction && canMakeCarousel && hasStudio,
  };
}
